var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleAngleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 16.8125L8.625 10.2812C8.5 10.125 8.5 9.90625 8.625 9.75L15.1875 3.21875C15.3438 3.0625 15.5625 3.0625 15.7188 3.21875L16.3438 3.8125C16.4688 3.96875 16.4688 4.21875 16.3438 4.34375L10.6875 10L16.3438 15.6875C16.4688 15.8125 16.4688 16.0625 16.3438 16.2188L15.7188 16.8125C15.5625 16.9688 15.3438 16.9688 15.1875 16.8125ZM10.7188 16.8125C10.5625 16.9688 10.3438 16.9688 10.1875 16.8125L3.625 10.2812C3.5 10.125 3.5 9.90625 3.625 9.75L10.1875 3.21875C10.3438 3.0625 10.5625 3.0625 10.7188 3.21875L11.3438 3.8125C11.4688 3.96875 11.4688 4.21875 11.3438 4.34375L5.6875 10L11.3438 15.6875C11.4688 15.8125 11.4688 16.0625 11.3438 16.2188L10.7188 16.8125Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAngleArrowLeft);
export default __webpack_public_path__ + "static/media/double-angle-arrow-left.79e631d5.svg";
export { ForwardRef as ReactComponent };